import { Link } from "react-router-dom";
import { motion } from "motion/react";
import { Badge } from "@/components/ui/badge";
import { blogPosts } from "@/lib/blog-posts";

export function BlogGrid() {
  return (
    <section className="mx-auto max-w-6xl px-6 pb-24">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        {blogPosts.map((post, index) => (
          <motion.div
            key={post.slug}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.5,
              delay: 0.2 + index * 0.1,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            <Link
              to={`/blog/${post.slug}`}
              className="group block overflow-hidden rounded-xl border border-border bg-card"
            >
              <div
                className={`aspect-video w-full rounded-t-xl bg-gradient-to-br ${post.gradient}`}
              />

              <div className="p-5">
                <Badge variant="secondary">{post.category}</Badge>

                <h3 className="mt-3 text-lg font-semibold text-foreground transition-colors group-hover:text-brand">
                  {post.title}
                </h3>

                <p className="mt-2 line-clamp-2 text-sm text-muted-foreground">
                  {post.excerpt}
                </p>

                <div className="mt-4 flex items-center gap-2 text-xs text-muted-foreground">
                  <span>{post.date}</span>
                  <span>&middot;</span>
                  <span>{post.readTime}</span>
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
